import { type Icon, IconCheck } from '@tabler/icons-react'
import { forwardRef } from 'react'
import { cn } from '#src/cn.ts'
import { Button, type ButtonProps } from '#src/components/Button/Button.tsx'

export interface IconCheckboxButtonProps extends Omit<
  ButtonProps,
  'value' | 'onChange' | 'children'
> {
  icon: Icon
  value: boolean
  onChange: (value: boolean) => void
  label: string
}

export const IconCheckboxButton = forwardRef<
  HTMLButtonElement,
  IconCheckboxButtonProps
>(
  (
    {
      icon: IconComponent,
      value,
      onChange,
      label,
      onClick,
      className,
      ...rest
    },
    ref
  ) => {
    return (
      <Button
        variant="outline"
        {...rest}
        ref={ref}
        role="checkbox"
        aria-checked={value}
        aria-label={label}
        className={cn('h-10 gap-2 px-2', className)}
        onClick={(event) => {
          onClick?.(event)
          onChange(!value)
        }}
      >
        <IconComponent
          className={value ? 'text-foreground' : 'text-muted-foreground'}
        />
        <span
          aria-hidden
          className={cn(
            'grid size-4 shrink-0 place-content-center rounded-[4px] border transition-colors',
            value
              ? 'border-primary bg-primary text-primary-foreground'
              : 'border-input bg-transparent'
          )}
        >
          {value && <IconCheck className="size-3.5" />}
        </span>
      </Button>
    )
  }
)
IconCheckboxButton.displayName = 'IconCheckboxButton'
